module.exports = __webpack_public_path__ + "static/media/portfolio-details-1.68f22bbb.jpg";